import React from "react";
import { BaseModal } from "./BaseModal";
import { useStore } from "../../stores/store";
import { ModalKeys } from "../../interfaces/config";

export default function ScaleConfirmationModal() {
  const { isActive, deactivateTool, setScaleType } = useStore();
  return (
    <BaseModal
      active={isActive(ModalKeys.SCALE_CONFIRMATION)}
      title="VERSION CHANGE"
    >
      <div className="p-3 font-helvetica text-sm">
        <p>Attention:</p>
        <p>
          The scale version allows a user to zoom the map to any desired scale.
          This will result in slower performance.
        </p>
        <p>If you wish to continue, please press 'OK'.</p>
      </div>
      <div className="bg-[#f5f5f5] border-t border-[#ddd] w-full text-right p-1">
        <button
          onClick={() => deactivateTool(ModalKeys.SCALE_CONFIRMATION)}
          className="btn-athena btn-sm mr-1"
        >
          Ok
        </button>
        <button
          onClick={() => {
            deactivateTool(ModalKeys.SCALE_CONFIRMATION);
            setScaleType("default");
          }}
          className="btn-athena btn-sm"
        >
          Cancel
        </button>
      </div>
    </BaseModal>
  );
}
